import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs';

import {ActionCode} from '@app/models';
import {PermissionsService} from '@app/services/permissions.service';

/**
 * Directiva estructural: renderiza el elemento solo si hay permiso.
 *   <button *hasPermission="'W-PAR.USUARIOS_ROLES_PERMISOS'; action: 'EDIT'">   (con acción)
 *   <section *hasPermission="'W-PAR.USUARIOS_ROLES_PERMISOS'">                  (solo acceso)
 * Se re-evalúa al cambiar el usuario logueado (login/logout/refresh).
 */
@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnDestroy {
  private referenceCode?: string;
  private action?: ActionCode;
  private hasView = false;
  private readonly subscription: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService,
  ) {
    this.subscription = this.permissionsService.permissions.subscribe(() => this.update());
  }

  @Input() set hasPermission(referenceCode: string | undefined) {
    this.referenceCode = referenceCode;
    this.update();
  }

  @Input() set hasPermissionAction(action: ActionCode | undefined) {
    this.action = action;
    this.update();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private update(): void {
    const allowed = this.isAllowed();
    if (allowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private isAllowed(): boolean {
    if (!this.referenceCode) {
      return false;
    }
    return this.action
      ? this.permissionsService.hasPermission(this.referenceCode, this.action)
      : this.permissionsService.hasAccess(this.referenceCode);
  }
}
